
export default {
    namespaced: true,
    state: {
        data: [],
        siteList: {},
        currentPage: 1,
        totalRows: null,
        perPage: 10,
        from: null,
        to: null,
        currentSiteId: null,
        minDate: null,
        maxDate: null,
    },
    getters: {
        MIN_DATE: state => {
            return state.minDate;
        },
        MAX_DATE: state => {
            return state.maxDate;
        },
        FROM: state => {
            return state.from;
        },
        TO: state => {
            return state.to;
        },
        SITE_LIST: state => {
            return state.siteList;
        },
        DATA: state => {
            return state.data;
        },

        CURRENT_PAGE: state => {
            return state.currentPage;
        },
        TOTAL_ROWS: state => {
            return state.totalRows;
        },
        PER_PAGE: state => {
            return state.perPage;
        },
        AMOUNT_PAGE: (state) => {
            return Math.ceil(state.totalRows/state.perPage);
        },
    },
    mutations: {
        MIN_DATE: (state, payload) => {
            return state.minDate = payload;
        },
        MAX_DATE: (state, payload) => {
            return state.maxDate = payload;
        },
        FROM: (state, payload) => {
            return state.from = payload;
        },
        TO: (state, payload) => {
            return state.to = payload;
        },
        SITE_LIST: (state, payload) => {
            return state.siteList = payload;
        },
        DATA: (state, payload) => {
            return state.data = payload;
        },
        CURRENT_PAGE: (state, payload) => {
            return state.currentPage = payload;
        },
        TOTAL_ROWS: (state, payload) => {
            return state.totalRows = payload;
        },
        PER_PAGE: (state, payload) => {
            return state.perPage = payload;
        },
    },
    actions: {
        GET_DATA: async ({state}, payload) => {
            payload.th.showOverlay ++;

            await payload.th.$store.dispatch('SEND_GET', {
                url: '/site-statistic'
                    +'?from='+ state.from
                    +'&to='+ state.to
                    +'&perPage='+ state.perPage
                    +'&currentPage='+ state.currentPage
                ,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (response) => {
                    state.data = response.statistic
                    state.totalRows = response.count
                },
                getResponse: () => {
                    payload.th.showOverlay --;
                },
            });
        },
        GET_EXTRIMAL_DATE: async ({state}, payload) => {
            payload.th.showOverlay ++;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/site-statistic-date',
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (response) => {
                    state.minDate = response.min
                    state.maxDate = response.max
                },
                getResponse: () => {
                    payload.th.showOverlay --;
                },
            });
        },

    }
}